// Auth Endpoints
export const LOGIN_API = "/api/users/jwt/";
export const REFRESH_API = "/api/users/jwt/refresh/";
export const LOGOUT_API = "/api/users/jwt/logout/";
export const VERIFY_EMAIL_API = "/api/users/verify-account";
export const REQUEST_PASSWORD_RESET_API = "/api/users/password-reset/request/";
export const RESET_PASSWORD_API = "/api/users/password-reset/confirm/";

// Public pages content endpoints
export const HOME_PAGE_CONTENT_API = "/api/cms/homepage/";
export const ABOUT_PAGE_CONTENT_API = "/api/cms/aboutpage/";
export const FEATURES_PAGE_CONTENT_API = "/api/cms/featurespage/";
export const BLOG_API = "/api/cms/blogs/";
